const pageToSkip = (page, pageSize) => {
    return (page - 1) * pageSize;
}

const skipToPage = (skip, pageSize) => {
    return (pageSize === 1 ? skip : Math.floor((skip+1) / pageSize)) + 1
}

export {pageToSkip, skipToPage}